const valueAt = (item, path) => path.split(".").reduce((value, key) => value?.[key], item);
const firstScalar = (item, paths) => paths.find(path => ["string", "number"].includes(typeof valueAt(item, path)) && String(valueAt(item, path)).trim()) || "";

export function inferPartnerResponseMapping(response) {
  const candidates = [];
  const visit = (value, path = "", depth = 0) => {
    if (Array.isArray(value)) {
      if (value.length && value[0] && typeof value[0] === "object" && !Array.isArray(value[0])) {
        const first = value[0];
        const title = firstScalar(first, ["title", "name", "info.title", "model.model_name"]);
        const score = (title ? 10 : 0) + (firstScalar(first, ["id", "display_id"]) ? 3 : 0) + (first.pricing ? 2 : 0);
        candidates.push({ path, first, score });
      }
      return;
    }
    if (!value || typeof value !== "object" || depth >= 4) return;
    Object.entries(value).forEach(([key, child]) => visit(child, path ? `${path}.${key}` : key, depth + 1));
  };
  visit(response);
  candidates.sort((a, b) => b.score - a.score);
  const match = candidates[0];
  if (!match || match.score < 10) throw new Error("Could not find a list of results with titles. Check the JSON response and map the fields manually.");
  const item = match.first;
  const monthly = firstScalar(item, ["pricing.monthly_instalment", "pricing.monthly_installment", "monthly_instalment", "monthly_installment"]);
  const attributesField = item.attributes && typeof item.attributes === "object" && !Array.isArray(item.attributes) ? "attributes" : "";
  return {
    resultsPath: match.path,
    idField: firstScalar(item, ["id", "display_id"]) || "id",
    titleField: firstScalar(item, ["title", "name", "info.title", "model.model_name"]),
    descriptionField: firstScalar(item, ["description", "summary", "seller_name"]),
    urlField: firstScalar(item, ["url", "link", "html_url"]),
    attributesField,
    ...(monthly ? { monthlyPath: monthly } : {}),
  };
}
